module.exports = __webpack_public_path__ + "static/uk-key-ecommerce-reforms-featured-d7ac2acc75212d43ee269629ee84acfd.png";